<template>
  <v-form ref="form" @submit.prevent="onSubmit">
    <v-card>
      <t-tabs
        :tabs="tabs"
        @submit="onSubmit"
        @tab-change="v => tab = v"
      >
        <template #window-footer>
          <div v-if="tab !== 2" class="d-flex justify-end">
            <v-col md="3">
              <v-btn
                type="submit"
                color="primary"
                size="large"
                class="w-100"
                :loading="loader.loading"
                :disabled="loader.loading"
              >
                Salvar
              </v-btn>
            </v-col>
          </div>
        </template>
      </t-tabs>
    </v-card>
  </v-form>
</template>

<script lang="ts" setup>
import TTabs from '@/components/TTabs.vue'
import TabBasicInfo from './partials/tab-basic-info.vue'
import TabTypes from './partials/tab-types.vue'
import TabAdditionalFields from './partials/tab-additional-fields.vue'
import { ref, useTemplateRef } from 'vue'
import EventConfiguration from '@/types/EventConfiguration'
import type { VForm } from 'vuetify/lib/components'
import { useSnackBar } from '@/stores/snackbar'
import { useLoader } from '@/stores/loader'
import { TabProp } from '@/types/vuetify/Tab'
import { useAbility } from '@casl/vue'

const snackbar = useSnackBar()

const loader = useLoader()

const { can } = useAbility()

const { editing = false } = defineProps<{ editing?: boolean }>()

const emit = defineEmits<(e: 'submit', model: EventConfiguration) => void>()

const form = useTemplateRef<VForm>('form')

const model = defineModel<EventConfiguration>({ required: true })

const tab = ref(0)

const tabs: TabProp[] = [
  {
    icon: 'fa-regular fa-pen-to-square',
    title: 'Informações Básicas',
    component: TabBasicInfo,
    props: { modelValue: model.value, editing },
  },
  {
    icon: 'fa-regular fa-money-bill-wave',
    title: 'Preços e Quantidades',
    component: TabTypes,
    props: { modelValue: model.value, editing },
    disabled: () => !model.value.mapping,
  },
  {
    icon: 'fa-regular fa-input-text',
    title: 'Campos Adicionais',
    component: TabAdditionalFields,
    props: { modelValue: model.value, editing },
    disabled: () => !model.value.id || !can('read', 'additional-fields'),
  },
]

async function onSubmit() {
  const validated = await form.value?.validate()

  if (!validated?.valid) {
    snackbar.show('Certifique-se de que os campos estão preenchidos corretamente em todas as abas.', 'error')
    return
  }

  emit('submit', model.value)
}

</script>
